module.exports = __webpack_public_path__ + "static/media/schedule.abb99682.svg";